import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';

const storedLanguage = globalThis.localStorage?.getItem('sqi-language');

void i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage === 'en' ? 'en' : 'th',
  fallbackLng: 'th',
  interpolation: { escapeValue: false },
});
document.documentElement.lang = storedLanguage === 'en' ? 'en' : 'th';

export async function setLanguage(language: 'th' | 'en'): Promise<void> {
  globalThis.localStorage?.setItem('sqi-language', language);
  document.documentElement.lang = language;
  await i18n.changeLanguage(language);
}

export default i18n;
